<template>
  <b-modal
    :id="modalId"
    ref="modal"
    :title="title"
    :hide-footer="hideFooter"
    :size="size"
    :hide-backdrop="hideBackdrop"
    :ok-title="okTitle"
    :ok-variant="okVariant"
    :cancel-title="cancelTitle"
    :cancel-variant="cancelVariant"
    @close="onClose"
    @cancel="onCancel"
    @ok="onConfirm"
    @hide="onHide"
  >
    <slot />
  </b-modal>
</template>

<script>
export default {
  name: 'ModalOverlay',
  props: {
    cancelTitle: {
      type: String,
      default: undefined,
    },
    cancelVariant: {
      type: String,
      default: undefined,
    },
    hideBackdrop: Boolean,
    hideFooter: Boolean,
    modalId: {
      type: String,
      required: true,
    },
    modalShow:Boolean,
    okTitle: {
      type: String,
      default: undefined,
    },
    okVariant: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods:{
    hide(){ this.$refs.modal.hide(); },
    onCancel(e){ this.$emit('cancelled', e); },
    onClose(e){ this.$emit('closed', e); },
    onConfirm(e){ this.$emit('confirmed', e); },
    onHide(e){ this.$emit('hide', e); },
    show() { this.$refs.modal.show(); },
  },
};
</script>

<style scoped>

</style>
